import abbottAndApi from "@/apis/liff/v2/proj/abbott-and";
import store from "@/store";
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters({
      queryData: "projAbbottAnd/queryData",
      couponType: "projAbbottAnd/couponType",
      redeemData: "projAbbottAnd/redeemData",
      user: "liffAuth/user",
    }),
  },
  methods: {
    ...mapActions('projAbbottAnd', ['setIsMember', 'setIsBindStore', 'setThanksMessage', 'setThanksTitle']),
    async joinChannel(channel) {
      try {
        await abbottAndApi.joinChannel(
          this.$route.params.orgCode,
          {
            channel: channel,
            brand: this.queryData.brand,
            coupon_code: this.couponType == 'ipd' ? "IPD_001" : this.queryData.coupon_code
          }
        );
      } catch (e) {
        this.setThanksMessage("綁定錯誤");
        this.$router.push({
          name: "LiffProjAbbottAndApplyFailed",
        });
      }
    },
    formatQueryData() {
      let query = this.queryData;
      let type = this.couponType || this.$route.params.couponType;
      switch (type) {
        case "ipd":
          query.coupon_code = "IPD_001";
          break;
        case "j5":
        case "j5-1":
          query.coupon_code = "WI_001";
          break;
        default:
          break;
      }
      return query;
    },
    async checkStoreCode() {
      try {
        const { data } = await abbottAndApi.checkStoreCode(
          this.$route.params.orgCode,
          {
            store_code: this.queryData.store_code,
          }
        );
        return data.data.is_exist;
      } catch (e) {
        this.setThanksMessage("店家代碼錯誤");
        this.$router.push({
          name: "LiffProjAbbottAndApplyFailed",
        });
        return false;
      }
    },
    async validate() {
      switch (this.couponType) {
        case "j4":
          return this.checkStoreCode();
        default:
          return true;
      }
    },
    async submit() {
      console.log("[AND Mixin] ========== submit() ==========");
      console.log("[AND Mixin] couponType:", this.couponType);
      console.log("[AND Mixin] queryData:", this.queryData);

      if (!this.validate()) {
        console.log("[AND Mixin] submit: Validation failed");
        this.setThanksMessage("不符合活動資格");
        this.$router.push({
          name: "LiffProjAbbottAndApplyFailed",
        });
        return;
      }
      const query = this.formatQueryData();
      console.log("[AND Mixin] submit: Formatted query data:", query);

      try {
        console.log("[AND Mixin] submit: Calling sendCoupon API...");
        const sendCouponResponse = await abbottAndApi.sendCoupon(this.$route.params.orgCode, {
          ...query,
          coupon_type: this.couponType || this.$route.params.couponType,
        });
        console.log("[AND Mixin] submit: sendCoupon success, calling registerCustomer...");
        await abbottAndApi.registerCustomer(this.$route.params.orgCode, {});
        console.log("[AND Mixin] submit: All done, redirecting to Thanks");
        this.setThanksMessage("成功領取");
        const firstCouponType = sendCouponResponse?.data?.data?.[0]?.type
        if (firstCouponType === 'Delivery') {
          this.redirectToOa();
          return;
        }
        this.$router.push({
          name: "LiffProjAbbottAndThanks",
        });
      } catch (e) {
        console.error("[AND Mixin] submit: Error occurred:", e);
        
        let errorCode = 0;
        let errorTitle = "領取失敗";
        let errorMessage = "您可能已參加其他藥局活動，或輸入兌換碼有誤。<br>若有疑問請洽0800-036-688，由專人為您服務，謝謝！";
        
        if (e.response && e.response.data) {
          const resData = e.response.data;
          errorCode = parseInt(resData.code, 10) || 0;
          if (resData.title) errorTitle = resData.title;
          if (resData.message) errorMessage = resData.message;
        }
        
        if (errorCode >= 90000 && errorCode <= 99999) {
          if (this.setThanksTitle) this.setThanksTitle(errorTitle);
          this.setThanksMessage(errorMessage);
        } else {
          if (this.setThanksTitle) this.setThanksTitle("領取失敗");
          this.setThanksMessage("您可能已參加其他藥局活動，或輸入兌換碼有誤。<br>若有疑問請洽0800-036-688，由專人為您服務，謝謝！");
        }

        this.$router.push({
          name: "LiffProjAbbottAndApplyFailed",
        });
      }
    },
    async checkAndMember() {
      try {
        const res = await abbottAndApi.checkMember(
          this.$route.params.orgCode,
          {}
        );

        this.setIsMember(res.data.is_member)

        if (!res.data.is_member) {
          await abbottAndApi.registerMember(this.$route.params.orgCode, {
            store_code: this.queryData.store_code,
            source: this.queryData.source,
          });
        }
      } catch (e) {
        this.setThanksMessage(e.response.data.message);
        this.$router.push({
          name: "LiffProjAbbottAndApplyFailed",
        });
      }
    },
    async checkMember() {
      console.log("[AND Mixin] ========== checkMember() ==========");
      console.log("[AND Mixin] couponType:", this.couponType);
      console.log("[AND Mixin] queryData:", this.queryData);

      switch (this.couponType) {
        case "ipd":
          console.log("[AND Mixin] >>> Entering IPD flow");
          try {
            console.log("[AND Mixin] Calling checkIsSendable API...");
            const { data } = await abbottAndApi.checkIsSendable(
              this.$route.params.orgCode,
              {
                coupon_code: this.queryData.coupon_code ?? 'IPD_001',
                qrcode: this.queryData.qrcode,
                event_name: this.queryData.event_name,
                brand: this.queryData.brand,
              }
            );

            console.log("[AND Mixin] checkIsSendable response:", data);

            if (data.data.is_sendable != 1) {
              console.log("[AND Mixin] IPD: Already redeemed, redirecting to ApplyFailed");
              this.setThanksMessage("已領取過");
              this.$router.push({
                name: "LiffProjAbbottAndApplyFailed",
              });
              return;
            }

            console.log("[AND Mixin] IPD: Calling checkMember API...");
            const res = await abbottAndApi.checkMember(
              this.$route.params.orgCode,
              {}
            );
            console.log("[AND Mixin] IPD checkMember response:", res.data);

            this.setIsMember(res.data.is_member)
            this.setIsBindStore(res.data.is_bind_store)

            if (!res.data.is_member) {
              console.log("[AND Mixin] IPD: Not a member, redirecting to LiffRegisterIndex");
              this.$router.push({
                name: "LiffRegisterIndex",
                params: {
                  orgCode: this.$route.params.orgCode,
                },
                // query: {
                //   redirect_action:
                //     this.$route.query.redirect_action ??
                //     "proj.abbott_and.branch_picker",
                //   redirect_button: this.$route.query.redirect_button ?? 1,
                //   success_button: this.$route.query.success_button ?? 0,
                // },
              });
            } else {
              console.log("[AND Mixin] IPD: Is a member, calling registerCustomer...");
              await abbottAndApi.registerCustomer(this.$route.params.orgCode);

              console.log("[AND Mixin] IPD: Redirecting to StorePicker");
              this.$router.push({
                name: "LiffProjAbbottAndStorePicker",
              });
            }
          } catch (e) {
            console.error("[AND Mixin] IPD: Error occurred:", e);
            this.setThanksMessage(e.response.data.message);
            this.$router.push({
              name: "LiffProjAbbottAndApplyFailed",
            });
          }
          break;
        case "j4":
          console.log("[AND Mixin] >>> Entering J4 (Ehopar) flow");
        try {
          console.log("[AND Mixin] J4: Calling applyEhoparRedeemCode with Id:", this.$route.query.Id);
          await abbottAndApi.applyEhoparRedeemCode(this.$route.params.orgCode, {
            code: this.$route.query.Id
          });

          console.log("[AND Mixin] J4: Calling checkMember API...");
          const res = await abbottAndApi.checkMember(this.$route.params.orgCode, {});
          console.log("[AND Mixin] J4 checkMember response:", res.data);

          this.setIsMember(res.data.is_member)
          this.setIsBindStore(res.data.is_bind_store)

          if (!res.data.is_member) {
            console.log("[AND Mixin] J4: Not a member, redirecting to LiffRegisterIndex");
            this.$router.push({
              name: "LiffRegisterIndex",
              params: {
                orgCode: this.$route.params.orgCode,
              },
            });
          } else {
            console.log("[AND Mixin] J4: Is a member, calling registerCustomer...");
            await abbottAndApi.registerCustomer(this.$route.params.orgCode, {});

            console.log("[AND Mixin] J4: Calling checkMember again to get store_code...");
            const res = await abbottAndApi.checkMember(this.$route.params.orgCode,{});
            console.log("[AND Mixin] J4 second checkMember response:", res.data);

            this.setIsMember(res.data.is_member)
            this.setIsBindStore(res.data.is_bind_store)

            console.log("[AND Mixin] J4: Redirecting to SendCoupon");
            this.$router.push({
              name: "LiffProjAbbottAndSendCoupon",
              params: { couponType: this.couponType },
            });
          }
        } catch (e) {
          console.error("[AND Mixin] J4: Error occurred:", e);
          this.setThanksMessage(e.response.data.message);
          this.$router.push({
            name: "LiffProjAbbottAndApplyFailed",
          });
        }
        break;
        case "j5":
        case "j5-1":
          console.log("[AND Mixin] >>> Entering J5/J5-1 flow");
          try {
            console.log("[AND Mixin] J5: Calling checkMember API...");
            const res = await abbottAndApi.checkMember(this.$route.params.orgCode, {});
            console.log("[AND Mixin] J5 checkMember response:", res.data);

            this.setIsMember(res.data.is_member)
            this.setIsBindStore(res.data.is_bind_store)

            if (!res.data.is_member) {
              console.log("[AND Mixin] J5: Not a member, redirecting to LiffRegisterIndex");
              this.$router.push({
                name: "LiffRegisterIndex",
                params: {
                  orgCode: this.$route.params.orgCode,
                },
                query: {
                  redirect_action:
                    this.$route.query.redirect_action ??
                    "proj.abbott_and.branch_picker",
                  redirect_button: this.$route.query.redirect_button ?? 1,
                  success_button: this.$route.query.success_button ?? 0,
                },
              });
            } else {
              console.log("[AND Mixin] J5: Is a member, calling registerCustomer...");
              await abbottAndApi.registerCustomer(this.$route.params.orgCode, {});

              // registerCustomer 會在後端設定 registered_at，需重新 fetchMe
              // 否則 MemberCenterEdit 的 checkPermission 會因為舊的 user 資料判定未註冊
              await store.dispatch('liffAuth/fetchMe');

              console.log("[AND Mixin] J5: Is a member, redirecting to MemberCenterEdit");
              this.$router.push({
                name: "LiffMemberCenterEdit",
                params: {
                  orgCode: this.$route.params.orgCode,
                },
              });
            }
          } catch (e) {
            console.error("[AND Mixin] J5: Error occurred:", e);
            this.setThanksMessage(e.response.data.message);
            this.$router.push({
              name: "LiffProjAbbottAndApplyFailed",
            });
          }
          break;
        default:
          console.log("[AND Mixin] >>> Entering DEFAULT flow (j1, j2, j3, etc.)");
          try {
            console.log("[AND Mixin] Default: Calling checkMember API with phone:", this.queryData.phone);
            const res = await abbottAndApi.checkMember(
              this.$route.params.orgCode,
              {
                phone: this.queryData.phone,
              }
            );
            console.log("[AND Mixin] Default checkMember response:", res.data);

            this.setIsMember(res.data.is_member)
            this.setIsBindStore(res.data.is_bind_store)

            if (res.data.is_member) {
              console.log("[AND Mixin] Default: Is a member, checking LINE ID...");
              if (res.data.is_same_line_id) {
                console.log("[AND Mixin] Default: LINE ID matches, redirecting to SendCoupon");
                this.$router.push({
                  name: "LiffProjAbbottAndSendCoupon",
                  params: { couponType: this.couponType },
                });
              } else {
                console.log("[AND Mixin] Default: LINE ID mismatch, redirecting to ApplyFailed");
                this.setThanksMessage("此手機與查詢會員不一致，請聯絡客服人員");
                this.$router.push({
                  name: "LiffProjAbbottAndApplyFailed",
                });
              }
            } else {
              console.log("[AND Mixin] Default: Not a member, redirecting to SendCoupon");
              this.$router.push({
                name: "LiffProjAbbottAndSendCoupon",
                params: { couponType: this.couponType },
              });
            }
          } catch (e) {
            console.error("[AND Mixin] Default: Error occurred:", e);
            this.setThanksMessage(e.response.data.message);
            this.$router.push({
              name: "LiffProjAbbottAndApplyFailed",
              query: {
                messages: e.response.data.message,
              },
            });
          }
          break;
      }
    },
    async confirmCoupon() {
      console.log("[AND Mixin] ========== confirmCoupon() ==========");
      console.log("[AND Mixin] redeemData:", this.redeemData);

      try {
        let storeCode = this.redeemData.store_code
        if (!this.redeemData.store_code) {
          console.log("[AND Mixin] confirmCoupon: No store_code in redeemData, fetching from checkMember...");
          const data = await abbottAndApi.checkMember(
            this.$route.params.orgCode,
            {}
          );
          storeCode = data.data.store_code
          console.log("[AND Mixin] confirmCoupon: Got store_code from checkMember:", storeCode);
        }

        const redeemPayload = {
          coupon_id: this.redeemData.coupon_id,
          verify_code: this.redeemData.verify_code,
          store_code: storeCode,
          item_id: this.redeemData?.item_id ?? null,
          coupon_type: this.redeemData.coupon_type,
          item_name: this.redeemData?.item_name ?? '',
          coupon_code: this.redeemData?.coupon_code ?? '',
          sales_info: this.redeemData?.sales_info ?? null,
        };
        console.log("[AND Mixin] confirmCoupon: Calling redeemCoupon API with:", redeemPayload);

        const res = await abbottAndApi.redeemCoupon(
          this.$route.params.orgCode,
          redeemPayload
        );
        console.log("[AND Mixin] confirmCoupon: redeemCoupon success, response:", res.data);
        console.log("[AND Mixin] confirmCoupon: Redirecting to CouponRedeemSuccess");

        this.$router.push({
          name: "LiffProjAbbottAndCouponRedeemSuccess",
          query: {
            qrcode1: res.data.data.qrcode1,
            qrcode2: res.data.data.qrcode2,
          },
        });
      } catch (e) {
        console.error("[AND Mixin] confirmCoupon: Error occurred:", e);
        console.error("[AND Mixin] confirmCoupon: Error response:", e.response?.data);

        const errorData = e.response?.data;
        // 根據 use_api_message 標誌決定顯示 API 錯誤訊息或預設錯誤訊息
        if (errorData?.use_api_message && errorData?.message) {
          console.log("[AND Mixin] confirmCoupon: Using API error message:", errorData.message);
          this.setThanksMessage(errorData.message);
        } else {
          console.log("[AND Mixin] confirmCoupon: Using default error message");
          this.setThanksMessage("兌換失敗");
        }

        this.$router.push({
          name: "LiffProjAbbottAndCouponRedeemFailed",
        });
      }
    },
    /**
     * 取得 2026 抽獎活動的累積次數
     * @returns {Promise<number>} earnCount
     */
    async fetchEarnCount() {
      try {
        const params = this.$route.query.event_code
          ? { event_code: this.$route.query.event_code }
          : {};
        const { data } = await abbottAndApi.getEarnCount(
          this.$route.params.orgCode,
          params
        );
        if (data.status === 1) {
          return data.result.earnCount;
        }
        return 0;
      } catch (e) {
        console.error('[AND Mixin] fetchEarnCount error:', e);
        return 0;
      }
    },
    redirectToOa() {
      window.location.href = `${process.env.VUE_APP_API_BASE_URL}/${this.$route.params.orgCode}/liff/general/redirect-to-oa`;
    },
  },
};
